import { render } from "./RoundIconButton.vue?vue&type=template&id=7f869eaa"
import script from "./RoundIconButton.vue?vue&type=script&lang=js"
export * from "./RoundIconButton.vue?vue&type=script&lang=js"
script.render = render

export default script